<template>
  <modal
    :show.sync="openModal"
    modal-classes="modal-dialog-centered modal-lg modalflight"
    body-classes=""
    @close="closeSurchargeModal"
    no-close-on-backdrop
  >
    <template slot="header">
      <h4 class="subtitle">Especial Conditions</h4>
    </template>

    <div class="pt-4 forms">
      <div class="row">
        <div class="col-lg-6 col-sm-8 col-8">
          <WSelect
            placeholder="Select Event"
            v-model="surcharge.type"
            :id="fieldId('event_type')"
            :name="fieldId('event_type')"
            filterable
            v-bind:class="{ 'is-invalid': $v.surcharge.type.$error }"
            markrequired
            label="Type Event"
          >
            <el-option
              v-for="option in SURCHARGE_TYPES"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </WSelect>
          <small class="invalid-feedback" v-if="$v.surcharge.type.$error"
            >Select a Event</small
          >
        </div>

        <div class="col-lg-6 col-sm-4 col-4">
          <label class="title-label ml-0">Active</label>
          <base-switch v-model="surcharge.status" class="mt-2"></base-switch>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-show="!['weekend_dates', 'night_fees'].includes(surcharge.type)"
        >
          <base-input label="From Date" markrequired>
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                altFormat: 'd-M-Y',
                altInput: true,
                minDate: minSelectableDate,
                dateFormat: 'Y-m-d',
                allowInput: true
              }"
              class="input-custom"
              v-model="surcharge.from_date"
              :id="fieldId('from_date')"
              :name="fieldId('from_date')"
              placeholder="From date"
              markrequired
            ></flat-picker>
          </base-input>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'seasonal'
            ].includes(surcharge.type)
          "
        >
          <base-input label="Start Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                enableTime: true,
                altInput: true,
                noCalendar: true,
                altFormat: 'G:i K',
                dateFormat: 'G:i K',
                time_24hr: false,
                wrap: true
              }"
              class="input-custom"
              v-model="surcharge.start_time"
              :id="fieldId('start_time')"
              :name="fieldId('start_time')"
              placeholder="Start Time"
            ></flat-picker>
          </base-input>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'seasonal'
            ].includes(surcharge.type)
          "
        >
          <base-input label="End Time">
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{
                enableTime: true,
                altInput: true,
                noCalendar: true,
                altFormat: 'G:i K',
                dateFormat: 'G:i K',
                time_24hr: false,
                wrap: true
              }"
              class="input-custom"
              v-model="surcharge.end_time"
              :id="fieldId('end_time')"
              :name="fieldId('end_time')"
              placeholder="End Time"
            ></flat-picker>
          </base-input>
        </div>

        <div class="col-lg-6 mb-4" v-if="surcharge.type === 'seasonal'">
          <label for class="title-label">Ends</label>

          <div class="row">
            <div class="col-lg-3 col-sm-4 col-4 align-self-center">
              <base-radio
                class="mr-5 ml-3"
                name="on"
                value="on"
                v-model="customEnd"
                >On</base-radio
              >
            </div>
            <div class="col-lg-7 col-sm-6 col-8 align-self-center">
              <base-input class="mb-0 mt-2">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{
                    altFormat: 'd-M-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    allowInput: true
                  }"
                  class="input-custom"
                  v-model="surcharge.to_date"
                  :id="fieldId('seasonal_end_on')"
                  :name="fieldId('seasonal_end_on')"
                  :disabled="!(customEnd === 'on')"
                  placeholder="End On"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>

        <div
          class="col-lg-3 col-sm-6 col-6"
          v-if="
            ![
              'blackouts',
              'availability_on_request',
              'weekend_dates',
              'night_fees'
            ].includes(surcharge.type)
          "
        >
          <label class="title-label ml-0">Frecuency Yearly</label>
          <base-switch v-model="surcharge.frequency" class="mt-2"></base-switch>
        </div>

        <div
          class="col-lg-6 mb-4"
          v-if="
            !['weekend_dates', 'night_fees', 'seasonal'].includes(
              surcharge.type
            )
          "
        >
          <label for class="title-label">Ends</label>

          <div class="row">
            <div
              class="col-lg-12 col-sm-12 col-12"
              v-if="
                ['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <base-radio
                class="mr-5 ml-3 mt-3"
                name="never"
                value="never"
                v-model="customEnd"
                >Never</base-radio
              >
            </div>

            <div class="col-lg-3 col-sm-4 col-4 align-self-center">
              <base-radio
                class="mr-5 ml-3 mt-2"
                name="on"
                value="on"
                v-model="customEnd"
                >On</base-radio
              >
            </div>
            <div class="col-lg-7 col-sm-6 col-8 align-self-center">
              <base-input class="mb-0">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{
                    altFormat: 'd-M-Y',
                    altInput: true,
                    minDate: minSelectableDate,
                    dateFormat: 'Y-m-d',
                    allowInput: true
                  }"
                  class="input-custom"
                  v-model="surcharge.to_date"
                  :id="fieldId('end_on')"
                  :name="fieldId('end_on')"
                  :disabled="!(customEnd === 'on')"
                  placeholder="End On"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="row">
            <div
              class="col-lg-4 col-sm-4 col-4 switch-sm"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label ml-0">Surcharge</label>

              <base-switch
                v-model="markupType"
                onText="%"
                offText="$"
                class="mt-2"
                @input="changeMarkupType"
              ></base-switch>
            </div>

            <div
              class="col-lg-4 col-sm-4 col-4 align-self-start"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label d-block">Value</label>
              <BaseNumberInput
                :id="fieldId('value_markup')"
                :name="fieldId('value_markup')"
                placeholder="Value Markup"
                v-model.number="surcharge.markup.value"
              />
            </div>

            <div
              class="col-lg-4 col-sm-4 col-4 switch-lg"
              v-if="
                !['blackouts', 'availability_on_request'].includes(
                  surcharge.type
                )
              "
            >
              <label class="title-label ml-0">Apply in</label>
              <base-switch
                v-model="markupApplyIn"
                onText="Gross"
                offText="Net"
                class="mt-2"
                @input="changeMarkupApplyIn"
              ></base-switch>
            </div>

            <div
              class="col-lg-12 mb-4 pl-3"
              v-show="surcharge.type === 'weekend_dates'"
            >
              <label for class="title-label-np">Days</label>

              <base-checkbox
                v-for="day in WEEKEND_DAY_OPTIONS"
                :key="day.value"
                :checked="isWeekendDaySelected(day.value)"
                @input="toggleWeekendDay(day.value, $event)"
              >
                {{ day.label }}
              </base-checkbox>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                v-bind:class="{
                  'is-invalid': $v.surcharge.description.$error
                }"
              >
                <label class="title-label"
                  ><span class="markrequired">*</span>Description</label
                >

                <el-input
                  v-model="surcharge.description"
                  placeholder="Type something here..."
                  :id="fieldId('description')"
                  :name="fieldId('description')"
                  maxlength="200"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  show-word-limit
                >
                </el-input>
              </div>
              <small
                class="invalid-feedback"
                v-if="$v.surcharge.description.$error"
                >Enter Min. 8 Characters</small
              >
            </div>
          </div>
        </div>

        <div class="col-12 alinmov2 mt-2">
          <base-button
            type="primary"
            class="min-button mb-0"
            :disabled="loadingRequest"
            @click="saveSurcharge()"
          >
            <i class="flaticon-floppy-disk"></i>Save
          </base-button>
        </div>
      </div>
    </div>

    <template slot="footer"> </template>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import { SurchargesAPI } from "../../../core/api";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import { DatePicker, TimeSelect } from "element-ui";
import { cloneDeep } from "lodash";
import { required, minLength } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import {
  SURCHARGE_TYPES,
  WEEKEND_DAY_OPTIONS
} from "../constants/surcharge.constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

/** Maximum surcharges of a type a rate can have. */
const MAX_NIGHT_FEES = 2;
const MAX_WEEKEND_FEES = 1;

/** Surcharge types that can repeat every year (`frequency`). */
const YEARLY_TYPES = ["special_event", "seasonal"];

/**
 * Tells whether a surcharge type can repeat every year.
 * @param {string} type - The surcharge type.
 * @returns {boolean} True for a special event or a seasonal fee.
 */
function supportsYearlyFrequency(type) {
  return YEARLY_TYPES.includes(type);
}

/**
 * Builds the form data of a new surcharge.
 * @returns {Object} An empty surcharge.
 */
function buildEmptySurcharge() {
  return {
    type: "blackouts",
    status: true,
    from_date: moment().format("YYYY-MM-DD"),
    start_time: "12:00 PM",
    to_date: moment()
      .add(7, "days")
      .format("YYYY-MM-DD"),
    end_time: "12:00 PM",
    markup: {
      type: "percentage",
      value: 0,
      apply_in: "gross"
    },
    frequency: false,
    description: "",
    custom: {
      repeat_on: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
      },
      end: false
    }
  };
}

export default {
  name: "SurchargeForm",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    timezone: {
      type: String,
      required: true
    },
    limit: {
      type: Array,
      required: true
    },
    surchargeId: {
      type: [String, null],
      default: null
    },
    payload: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      surcharge: buildEmptySurcharge(),
      editingSurchargeId: null,
      markupType: true,
      markupApplyIn: true,
      openModal: false,
      SURCHARGE_TYPES,
      WEEKEND_DAY_OPTIONS,
      customEnd: "on",
      loadingRequest: false
    };
  },
  watch: {
    show: {
      handler: function(current) {
        this.openModal = current;
      },
      deep: true
    },
    customEnd: function(value) {
      this.surcharge.custom.end = value === "never";
    },
    surchargeId: {
      handler: function(current) {
        if (current) {
          this.loadSurchargeToDuplicate(current);
        }
      },
      deep: true
    },
    payload: {
      handler: function(current) {
        if (current) {
          this.populateSurchargeToEdit(current);
        }
      },
      deep: true
    }
  },
  methods: {
    fieldId(name) {
      return `${name}-${this._uid}`;
    },
    closeSurchargeModal() {
      this.$emit("closeSurchargeModal", false);
      this.resetSurcharge();
    },
    resetSurcharge() {
      this.surcharge = buildEmptySurcharge();
      this.editingSurchargeId = null;
      this.customEnd = "on";
      this.markupType = true;
      this.markupApplyIn = true;
      this.loadingRequest = false;
      this.$v.surcharge.$reset();
    },
    populateSurcharge(surcharge) {
      this.surcharge.type = surcharge.type;
      this.surcharge.status = surcharge.status;
      this.surcharge.from_date = surcharge.from_date;
      this.surcharge.start_time = surcharge.start_time;
      this.surcharge.to_date = surcharge.to_date;
      this.surcharge.end_time = surcharge.end_time;
      this.surcharge.markup = cloneDeep(surcharge.markup);
      this.surcharge.frequency = surcharge.frequency;
      this.surcharge.description = surcharge.description;
      this.surcharge.custom.repeat_on = {
        ...buildEmptySurcharge().custom.repeat_on,
        ...surcharge.custom.repeat_on
      };
      this.surcharge.custom.end = surcharge.custom.end;
      this.customEnd = surcharge.custom.end ? "never" : "on";
      this.markupType = surcharge.markup.type === "percentage";
      this.markupApplyIn = surcharge.markup.apply_in === "gross";
    },
    populateSurchargeToEdit(surcharge) {
      this.editingSurchargeId = surcharge._id;
      this.populateSurcharge(surcharge);
    },
    async loadSurchargeToDuplicate(surchargeId) {
      try {
        let { data } = await SurchargesAPI.getSurchargeById(
          surchargeId,
          this.sesion.token
        );
        if (data) {
          this.populateSurcharge(data);
        } else {
          this.notifyOperationError();
        }
      } catch (error) {
        this.notifyOperationError();
      }
    },
    isWeekendDaySelected(day) {
      return this.surcharge.custom.repeat_on[day] === true;
    },
    toggleWeekendDay(day, checked) {
      this.surcharge.custom.repeat_on[day] = checked;
    },
    countOtherSurchargesOfType(type) {
      return this.limit.filter(
        surcharge =>
          surcharge.type === type && surcharge._id !== this.editingSurchargeId
      ).length;
    },
    canHaveAnotherNightFee() {
      return this.countOtherSurchargesOfType("night_fees") < MAX_NIGHT_FEES;
    },
    canHaveAnotherWeekendFee() {
      return (
        this.countOtherSurchargesOfType("weekend_dates") < MAX_WEEKEND_FEES
      );
    },
    buildSurchargePayload() {
      const surcharge = cloneDeep(this.surcharge);
      surcharge.frequency =
        supportsYearlyFrequency(surcharge.type) && surcharge.frequency;
      return surcharge;
    },
    notifyWarning(message) {
      this.$notify({
        type: "warning",
        title: "Important!",
        message: message,
        icon: "flaticon-warning-1"
      });
    },
    notifyOperationError() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The Operation couldn't be completed. Please try again",
        icon: "flaticon-remove"
      });
    },
    saveSurcharge() {
      if (this.$v.surcharge.$invalid) {
        this.$v.surcharge.$touch();
        this.notifyWarning("Please complete the required attributes");
        return;
      }
      if (
        this.surcharge.type === "night_fees" &&
        !this.canHaveAnotherNightFee()
      ) {
        this.notifyWarning("You can only have two nightly events.");
        return;
      }
      if (
        this.surcharge.type === "weekend_dates" &&
        !this.canHaveAnotherWeekendFee()
      ) {
        this.notifyWarning("You can only have one weekend fee event.");
        return;
      }
      const surcharge = this.buildSurchargePayload();
      if (this.editingSurchargeId) {
        this.updateSurcharge(this.editingSurchargeId, surcharge);
      } else {
        this.createSurcharge(surcharge);
      }
    },
    async createSurcharge(surcharge) {
      try {
        this.loadingRequest = true;
        let { data } = await SurchargesAPI.createSurcharge(
          surcharge,
          this.sesion.token
        );
        this.loadingRequest = false;
        if (data) {
          this.$emit("addSurcharge", {
            status: true,
            surcharge: data
          });
          this.resetSurcharge();
        } else {
          this.notifyOperationError();
        }
      } catch (error) {
        this.loadingRequest = false;
        this.notifyOperationError();
      }
    },
    async updateSurcharge(surchargeId, surcharge) {
      try {
        this.loadingRequest = true;
        let { data } = await SurchargesAPI.updateSurchargeById(
          surchargeId,
          surcharge,
          this.sesion.token
        );
        this.loadingRequest = false;
        if (data) {
          this.$emit("surchargeEdit", {
            status: true,
            surcharge: data
          });
          this.resetSurcharge();
        } else {
          this.notifyOperationError();
        }
      } catch (error) {
        this.loadingRequest = false;
        this.notifyOperationError();
      }
    },
    changeMarkupType(value) {
      this.surcharge.markup.type = value ? "percentage" : "money";
    },
    changeMarkupApplyIn(value) {
      this.surcharge.markup.apply_in = value ? "gross" : "net";
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    minSelectableDate() {
      return this.editingSurchargeId ? null : "today";
    },
    ...mapGetters(["sesion"])
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    WSelect
  },
  validations: {
    surcharge: {
      type: {
        required
      },
      description: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
